/*
 * Parsley validators for the password forms (set, reset and change password)
*/
(function($) {
	window.Parsley.addValidator("equals", {
		requirementType: "string",
		validateString: function(value, element) {
			return value == $(element).val();
		}
	});
	window.Parsley.addValidator("notequalto", {
		requirementType: "string",
		validateString: function(value, element) {
			return value !== $(element).val();
		}
	});
})(jQuery);
